(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nc-quantity-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nc-quantity-selector')) {
    customElements.define('nc-quantity-selector', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('change', () => this.updateSelection(true), { signal: this.controller.signal });
        queueMicrotask(() => this.updateSelection(false));
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      updateSelection(announce) {
        if (!this.isConnected) return;
        const selected = this.querySelector('input[name="quantity"]:checked:not(:disabled)');
        const form = this.closest('form');
        if (!selected || !form) return;
        const button = form.querySelector('[ref="addToCartButton"]');
        const content = button?.querySelector('.add-to-cart-text__content');
        if (button && content && !button.disabled) {
          let total = content.querySelector('.nc-quantity__button-total');
          if (!total) {
            total = document.createElement('span');
            total.className = 'nc-quantity__button-total';
            total.setAttribute('aria-hidden', 'true');
            content.append(total);
          }
          total.textContent = ` · ${selected.dataset.total}`;
          button.setAttribute('aria-label', `${button.dataset.addToCartText}: ${selected.dataset.quantityLabel}, ${this.dataset.totalLabel} ${selected.dataset.total}`);
        }
        if (announce) {
          this.querySelector('.nc-quantity__announcement').textContent = `${selected.dataset.quantityLabel}. ${this.dataset.totalLabel} ${selected.dataset.total}.`;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
